export default __webpack_public_path__ + "static/media/onevest.46ad548c.svg";